import React from 'react';
import PropTypes from 'prop-types';
import Centrifuge from 'centrifuge';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';

import {
  CENTRIFUGE_BASE_URL,
  CENTRIFUGE_USER,
  CENTRIFUGE_TIMESTAMP,
  CENTRIFUGE_TOKEN,
} from 'config';

import {
  RELOAD,
  REDIRECT,
  TAB,
  STACK_NOTIFICATION,
  SWEET_ALERT_NOTIFICATION,
  INFO,
} from 'constants/websocketActions';

// styles
import styles from './styles';

let centrifuge = null;

class WebSocket extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    user: PropTypes.object,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  static childContextTypes = {
    WebsocketCenter: PropTypes.object,
  };

  state = {
    subCollection: {},
  };

  getChildContext() {
    return {
      WebsocketCenter: {
        subscribe: this.subscribe.bind(this),
        unsubscribe: this.unsubscribe.bind(this),
        info: this.info.bind(this),
        close: this.close.bind(this),
      },
    };
  }

  componentWillMount() {
    this.open();
  }

  componentWillReceiveProps(nextProps) {
    const { user } = this.props;

    if ((user.id === undefined) && nextProps.user.id !== undefined) {
      this.subscribe(nextProps.user.uuid, this.actionDispatcher.bind(this));
    }

    if (user.id && nextProps.user.id && (nextProps.user.id !== user.id)) {
      this.unsubscribe(user.uuid);
      this.subscribe(nextProps.user.uuid);
    }
  }

  info() {
    const { subCollection } = this.state;
    return {
      subCollection,
      centrifuge,
    };
  }

  open() {
    if (centrifuge) throw new Error('The connection has already been configured');
    centrifuge = new Centrifuge({
      url: `${CENTRIFUGE_BASE_URL}/connection`,
      user: CENTRIFUGE_USER,
      timestamp: CENTRIFUGE_TIMESTAMP,
      token: CENTRIFUGE_TOKEN,
    });

    this.socketPromise = new Promise((resolve, reject) => {
      centrifuge.on('connect', resolve);
      centrifuge.on('disconnect', reject);
      centrifuge.connect();
    });
    return this.socketPromise;
  }

  unsubscribe(endpoint) {
    const { subCollection } = this.state;
    if (!centrifuge) throw new Error('The connection has not been configured');
    if (subCollection[endpoint]) {
      if (subCollection[endpoint].listenners === 1) {
        subCollection[endpoint].sub.unsubscribe();
        delete subCollection[endpoint];
      } else {
        this.setState(prevState => ({
          subCollection: {
            ...prevState.subCollection,
            [endpoint]: {
              sub: prevState.subCollection.sub,
              listenners: prevState.subCollection[endpoint].listenners - 1,
            },
          },
        }));
      }
    } else {
      throw new Error('Trying to unsubscribe to an unexisting channel');
    }
  }

  subscribe(endpoint, callbacks) {
    const { subCollection } = this.state;
    if (!centrifuge) throw new Error('The connection has not been configured');
    if (subCollection[endpoint]) {
      this.setState(prevState => ({
        subCollection: {
          ...prevState.subCollection,
          [endpoint]: {
            sub: prevState.subCollection.sub,
            listenners: prevState.subCollection[endpoint].listenners + 1,
          },
        },
      }));
      return subCollection[endpoint].sub;
    }

    const sub = centrifuge.subscribe(endpoint, callbacks);
    this.setState(prevState => ({
      subCollection: {
        ...prevState.subCollection,
        [endpoint]: { sub, listenners: 1 },
      },
    }));
    return sub;
  }

  close() {
    if (!centrifuge) throw new Error('The connection has not been configured');

    centrifuge.disconnect();
    centrifuge = null;
  }

  actionDispatcher(websocketMessage) {
    const { NotificationCenter } = this.context;

    const { data } = websocketMessage;
    switch (data.action) {
      case INFO:
        console.log(navigator.userAgent);
        break;
      case RELOAD:
        window.location.reload();
        break;
      case REDIRECT:
        window.location.replace(data.payload);
        break;
      case TAB:
        window.open(data.payload, '_blank');
        break;
      case STACK_NOTIFICATION:
        NotificationCenter.stack(
          data.payload.notification,
          data.payload.actions,
        );
        break;
      case SWEET_ALERT_NOTIFICATION:
        NotificationCenter.sweetAlert(
          data.payload.notification,
          data.payload.actions,
        );
        break;
      default:
        console.log('Default');
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div>
        {children}
      </div>
    );
  }
}

export default withStyles(styles)(WebSocket);
